import { all, takeLatest, call, put } from 'redux-saga/effects';
import _ from 'lodash';
import { ENDPOINT_PERGUNTAS } from '~/config/constants';
import { Types, loadPerguntasFailure, loadPerguntasSuccess } from './actions';
import api from '../../../config/axios';
import { toggleLoading } from '~/store/modules/loading/actions';

export function* loadPerguntas({ payload }) {
  try {
    yield put(toggleLoading(true));
    const tipoEstabelecimento =
      payload.statusEstabelecimento !== 'ativo' ? 'EC_INATIVO' : 'EC_ATIVO';

    const chamadadas = [
      api.get(ENDPOINT_PERGUNTAS, {
        params: { tipoEstabelecimento: 'TODOS_ECS' },
      }),
      api.get(ENDPOINT_PERGUNTAS, {
        params: { tipoEstabelecimento },
      }),
    ];

    const responses = yield all(
      chamadadas.map(chamada =>
        call(() =>
          chamada.then(
            data => {
              return { data, status: true };
            },
            e => {
              return { data: e, status: false };
            },
          ),
        ),
      ),
    );

    let perguntas = [];
    responses.forEach(response => {
      if (response.status) {
        const { data } = response.data;
        perguntas = [...perguntas, ...data.result];
      }
    });

    if (perguntas.length === 0) {
      throw new Error('Nenhuma pergunta definida');
    }

    perguntas = _.orderBy(perguntas, 'ordem', 'asc');

    const perguntasTratadas = perguntas.map(item => ({
      code: item.id,
      order: item.ordem,
      label: item.descricao,
      type: item.tipoResposta,
      required: String(item.tipoPergunta).toLowerCase() === 'obrigatorio',
      estabelecimento: item.tipoEstabelecimento,
      tipoRespostaPadrao: item.tipoRespostaPadrao,
      respostaPadrao: item.respostaPadrao,
    }));

    yield put(loadPerguntasSuccess(perguntasTratadas));
  } catch (e) {
    yield put(loadPerguntasFailure());
  } finally {
    yield put(toggleLoading(false));
  }
}

export default all([takeLatest(Types.REQUEST, loadPerguntas)]);
